import { Injectable } from '@angular/core';
import { BehaviorSubject, merge, fromEvent, Observable, Observer } from 'rxjs';
import { map } from 'rxjs/operators';

export class ShareDataService {
    private Behavior = new BehaviorSubject<any>({ AttributeID: [], FilterAttribute: '' });
    BehaviorObservable = this.Behavior.asObservable();

    private MapBehavior = new BehaviorSubject<any>("");
    MapBehaviorObservable = this.MapBehavior.asObservable();

    private reloadSubOrdinate = new BehaviorSubject<boolean>(false);
    reloadSubOrdinateObservable = this.reloadSubOrdinate.asObservable();

    private MapDateBehavior = new BehaviorSubject<any>("");
    MapDateObservable = this.MapDateBehavior.asObservable();

    private HeaderBehavior = new BehaviorSubject<boolean>(false);
    HeaderBehaviorObservable = this.HeaderBehavior.asObservable();

    private InLineCheckbox = new BehaviorSubject<boolean>(false);
    InLineCheckboxObservable = this.InLineCheckbox.asObservable();

    OnCheckBoxChange(data: any) {
        this.InLineCheckbox.next(data);
    }
    ShareData(data: any) {
        this.Behavior.next(data);
    }
    UpdateMap(data: any) {
        this.MapBehavior.next(data);
    }
    UpdateMapDate(data: any) {
        this.MapDateBehavior.next(data);
    }
    reloadSuperVisorSubOrdinate(data: any) {
        this.reloadSubOrdinate.next(data);
    }
    UpdateHeader(data: any) {
        this.HeaderBehavior.next(data);
    }

    ////////////////////////////////////
    public isUserLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    ////////////////////////////////////////////////////
    createOnline$() {
        return merge<any>(
            fromEvent(window, 'offline').pipe(map(() => false)),
            fromEvent(window, 'online').pipe(map(() => true)),
            new Observable((sub: Observer<boolean>) => {
                sub.next(navigator.onLine);
                sub.complete();
            }));
    }
}